module.exports = __webpack_public_path__ + "img/htdxbanner_sample.c86d608f.png";